














































import { Component, Vue } from 'vue-property-decorator'
import { AppModule } from '@/store/modules/app'
import { UserModule } from '@/store/modules/user'
import { EmptyForm } from '@/utils/emptyForm'
import { NBMessageSuccess, NBMessageWarning } from '@/utils/nBMessage'
import { changePwd } from '@/api/UserAdmin'
import { ChangePwd } from '@/types/UserAdmin'
import Hamburger from '@/components/Hamburger/index.vue'
import { DialogMain } from '@/components/index'
@Component({
  name: 'Navbar',
  components: {
    Hamburger,
    DialogMain,
  },
})
export default class extends Vue {
  form = {
    userName: '',
    user: {}
  }
  /**
   * dialogVisible dialog 状态
   * oldPassword 旧密码
   * newPassword 新密码
   * confirmPwd  确认密码
   */
  dialogVisible: boolean = false
  dialogForm = {
    oldPassword: '',
    newPassword: '',
    confirmPwd: ''
  }
  get sidebar() {
    return AppModule.sidebar
  }

  get device() {
    return AppModule.device.toString()
  }

  get avatar() {
    return UserModule.avatar
  }

  private toggleSideBar() {
    AppModule.ToggleSideBar(false)
  }

  private handleLogout() {
    localStorage.removeItem('user')
    this.$router.push(`/login`)
  }

  handleCommand(command: string) {
    switch (command) {
      case 'edit':
        this.dialogVisible = true
        break

      default:
        this.handleLogout()
        break
    }
  }
  /**
 * 确认
 */
  async handleConfirm() {
    const { oldPassword, newPassword, confirmPwd } = this.dialogForm
    if (oldPassword === '') {
      NBMessageWarning(this, { message: '旧密码不能为空' })
      return
    }
    if (newPassword === '') {
      NBMessageWarning(this, { message: '新密码不能为空' })
      return
    }
    if (newPassword !== confirmPwd) {
      NBMessageWarning(this, { message: '新密码不一致，请重新输入' })
      return
    }
    const { account } = (this.form.user as any)

    const params:ChangePwd = {
      account,
      oldPassword,
      newPassword
    }
    const { data } = await changePwd(params)
    if (data) {
      NBMessageSuccess(this, { message: '密码修改成功请重新登录' })
      this.handleLogout()
    }
  }
  handleEmpty() {
    EmptyForm(this.dialogForm)
    this.dialogVisible = false
  }
  created() {
    this.getLocalData()
  }
  getLocalData() {
    var _user = localStorage.getItem('user')
    var user = JSON.parse((_user as any))

    this.form.userName = user.account
    this.form.user = user
  }
}
